// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgFacebookIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M16.63 11.99h-2.705v9.974H9.911V11.99H8V8.466h1.909v-2.28c0-1.631.75-4.186 4.05-4.186l2.974.011v3.423h-2.157c-.354 0-.853.183-.853.96v2.072h3.06z"
    />
  </g>
);
export default SvgFacebookIcon;
SvgFacebookIcon.displayName = 'SvgFacebookIcon';
